// extracted by mini-css-extract-plugin
export default {"jumbotron-home":"HomePage_jumbotron-home__tFZpu","title-container":"HomePage_title-container__sDSIy","freepik-quote-container":"HomePage_freepik-quote-container__xvPEV"};